import { useState } from 'react';
import { getAccessToken } from "../../../api/session";

// This app stores the authenticated user (including accessToken) in localStorage.
// The legacy BFF used to mint/refresh tokens via a HomeController endpoint.
// In SPA-only mode, we just read the stored token.

export default function useToken() {
    const [token, setToken] = useState(getAccessToken() || "");

    const saveToken = (userToken) => {
        setToken(userToken || "");
    };

    return { setToken: saveToken, token };
}
